import { NoteRecord, Transfer } from "fe-shared-transactions/src/types";
import {
  Address,
  Assignee,
  CountryCode,
  DocumentsResponse,
  ScaleTicket,
  TransactionWarehouse,
} from "fe-shared-transactions/src/types/details";
import { BusinessRole } from "fe-shared/src/types/domain";

export interface Company {
  regNumber: number;
  businessRoleCode: BusinessRole;
  companyId: number;
  displayName: string;
}

export enum InventoryAdjustmentStatusCode {
  Submitted = "Submitted",
  InReview = "Reviewing",
  Invalid = "Invalid",
  Reviewed = "Reviewed",
  Approved = "Approved",
}

export interface InventoryAdjustment {
  overallAdjustmentId: number;
  overallAdjustmentNumber: "string";
  statusCode: InventoryAdjustmentStatusCode;
  completedDate: string;
  createdBy: string;
}

export interface GridInventoryAdjustment extends InventoryAdjustment {
  participantRegNumber: string;
  participantDisplayName: string;
  assigneeDisplayName: string;
  assigneeId: number;
}

export interface GridInventoryAdjustmentExport extends GridInventoryAdjustment {
  transactionNumber: string;
  scaleTicketNumber: string;
  adjustmentDate: string,
  regulatoryYear?: string;
  addorSub: string;
  weight?: string;
  quantity?: string;
  approvedBy?: string;
  approvedDate?: string;
  tireType?: string;
  materialType?: string;
  comment: string;
  overallAdjustmentNotes: string[];
  supportDocuments: string;
  address: Address
  historyLogs?: NoteRecord[];
  notes?: NoteRecord[];
}

export interface InventoryAdjustmentDetails extends InventoryAdjustment {
  attachments: DocumentsResponse[];
  assignee?: Assignee | null;
  adjustmentDate?: string;
  scaleTicket?: ScaleTicket;
  ownerCompany: Company;
  warehouse: TransactionWarehouse;
  addition: Transfer;
  subtraction: Transfer;
}

export interface GridInventoryAdjustmentList<
  T extends GridInventoryAdjustment
> {
  total: number;
  overallAdjustments: T[];
}

export type ActionType = "addition" | "subtraction";
